import React, { useEffect, useState } from "react";
import { fetchTrips } from "../../utils/matchingApi";
import { SideRows } from "../ui/SidePanel";
import { PartyCard } from "../ui/cards";
import { D } from "../search/icons";
import { fmtMoney, fmtDate } from "./useFleet";

const TRIP_TEXT = { CREATED: "Рейс назначен", IN_PROGRESS: "В пути" };

/**
 * «Активный заказ» in the fleet side page: for a vehicle that is in a trip, the accepted order —
 * route, cargo, dates, agreed price and the shipper (name, company, phone) — from GET /m/trips.
 */
export default function ActiveOrder({ vehicleId }) {
  const [state, setState] = useState({ loading: true, trip: null, error: "" });
  useEffect(() => {
    let alive = true;
    setState({ loading: true, trip: null, error: "" });
    fetchTrips("?limit=200")
      .then((r) => {
        if (!alive) return;
        const trip = (r?.trips || [])
          .filter((t) => Number(t.vehicle_id) === Number(vehicleId) && t.as !== "owner" && ["CREATED", "IN_PROGRESS"].includes(t.status))
          .sort((a, b) => String(b.created_at).localeCompare(String(a.created_at)))[0];
        setState({ loading: false, trip: trip || null, error: "" });
      })
      .catch(() => alive && setState({ loading: false, trip: null, error: "Не удалось загрузить активный заказ" }));
    return () => {
      alive = false;
    };
  }, [vehicleId]);

  if (state.loading) return <p className="side-note">Загружаем активный заказ…</p>;
  if (state.error) return <p className="side-error">{state.error}</p>;
  if (!state.trip) {
    return (
      <div className="drawer-empty">
        <h3>Активного заказа нет</h3>
        <p>Машина отмечена «В рейсе», но принятого заказа на платформе нет.</p>
      </div>
    );
  }
  const t = state.trip;
  const l = t.load || {};
  const cur = t.agreed_currency || l.currency;
  const price = t.agreed_amount ?? l.price;
  const dates = l.loading_from ? fmtDate(l.loading_from) + (l.loading_to && l.loading_to !== l.loading_from ? `–${fmtDate(l.loading_to)}` : "") : null;
  return (
    <section aria-label="Активный заказ" className="active-order">
      <div className="requests-heading">
        <strong>Активный заказ</strong>
        <span className="side-tags">
          <span>{TRIP_TEXT[t.status] || t.status}</span>
        </span>
      </div>
      <SideRows
        rows={[
          ["Груз", `#${String(t.load_id).toUpperCase()}`],
          ["Маршрут", l.from && l.to ? `${l.from} → ${l.to}` : null],
          ["Погрузка", dates],
          ["Вес / объём", [l.weight != null ? `${l.weight} т` : null, l.volume != null ? `${l.volume} м³` : null].filter(Boolean).join(" / ")],
          ["Кузов", l.body_type_name],
          ["Цена", price != null ? fmtMoney(price, cur) : "по договорённости"],
          ["Комментарий", l.comment],
        ]}
      />
      <div style={{ marginTop: 10 }}>
        <PartyCard name={t.owner?.name} company={t.owner?.company} phone={t.owner?.phone} type="Заказчик" icon={D.building} />
      </div>
    </section>
  );
}
